(function() {
  angular.module('cfn').factory('Fertilizer', Fertilizer);
  Fertilizer.$inject = ['dataSource.factory'];

  function Fertilizer(dataSource) {
    return dataSource('fertilizer').getRestService();
  }
})();
